export default "/images/cb0b3ebc78bc8afd25bdfd45d0e41590.png";